import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPage } from "../../store/helpers/helpersSlice";
import { addPay } from "../../store/story/storySlice";
import { NavLink } from "react-router-dom";
import Success from "../Theme/Icons/Success";

export default function SuccessfullyPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPage("successfullyPay"));
  }, []);

  return (
    <div class="h-[1024px] flex items-center justify-center">
      <div class="flex flex-col justify-center items-center">
        <div class="pb-[40px]">
          <Success />
        </div>
        <div class="items-center text-center pb-[32px]">
          <h1 class="text-main-color text-textSec text-[32px] font-[400] pb-[16px]">
            Payment Successfully
          </h1>
          <p class="text-[#C5C3C3] text-textSec text-[16px] font-[400] pb-[6px]">
            Thank you for ordering and creating a book with Crazyprints, we will
            start processing your order. Keep checking the status of your order.
          </p>
        </div>
        <div class="flex items-center gap-[24px] max-[420px]:flex-col">
          <NavLink to={"/"}>
            <button
              class="btn-second flex items-center justify-center"
              onClick={() => {
                dispatch(addPay(false));
                // dispatch(openModal(true));
              }}
            >
              Home
            </button>
          </NavLink>
          <NavLink to={"/"}>
            <button
              class="btn flex items-center justify-center "
              onClick={() => {
                dispatch(addPay(false));
                // dispatch(openModal(true));
              }}
            >
              Order Tracking
            </button>
          </NavLink>
        </div>
      </div>
    </div>
  );
}
